import { render, staticRenderFns } from "./connectMarketplace.vue?vue&type=template&id=20332b14&scoped=true"
import script from "./connectMarketplace.vue?vue&type=script&lang=js"
export * from "./connectMarketplace.vue?vue&type=script&lang=js"
import style0 from "./connectMarketplace.vue?vue&type=style&index=0&id=20332b14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20332b14",
  null
  
)

export default component.exports